import "@turf/turf";
import "./index.es175.js";
import { rgbArrayToHex as o } from "./index.es277.js";
import "./index.es176.js";
const e = {
  cape_hh_groupa: {
    color: o([80, 33, 144]),
    value: "A - Power Elite",
    categoricalLookup: ["A_p", "a_p"],
    visible: !0
  },
  cape_hh_groupb: {
    color: o([145, 109, 243]),
    value: "B - Flourishing Families",
    categoricalLookup: ["B_p", "b_p"],
    visible: !0
  },
  cape_hh_groupc: {
    color: o([175, 59, 179]),
    value: "C - Booming with Confidence",
    categoricalLookup: ["C_p", "c_p"],
    visible: !0
  },
  cape_hh_groupd: {
    color: o([237, 116, 245]),
    value: "D - Suburban Style",
    categoricalLookup: ["D_p", "d_p"],
    visible: !0
  },
  cape_hh_groupe: {
    color: o([169, 167, 208]),
    value: "E - Thriving Boomers",
    categoricalLookup: ["E_p", "e_p"],
    visible: !0
  },
  cape_hh_groupf: {
    color: o([16, 58, 147]),
    value: "F - Promising Families",
    categoricalLookup: ["F_p", "f_p"],
    visible: !0
  },
  cape_hh_groupg: {
    color: o([235, 66, 39]),
    value: "G - Young City Solos",
    categoricalLookup: ["G_p", "g_p"],
    visible: !0
  },
  cape_hh_grouph: {
    color: o([219, 80, 119]),
    value: "H - Bourgeois Melting Pot",
    categoricalLookup: ["H_p", "h_p"],
    visible: !0
  },
  cape_hh_groupi: {
    color: o([234, 150, 74]),
    value: "I - Family Union",
    categoricalLookup: ["I_p", "i_p"],
    visible: !0
  },
  cape_hh_groupj: {
    color: o([184, 52, 87]),
    value: "J - Autumn Years",
    categoricalLookup: ["J_p", "j_p"],
    visible: !0
  },
  cape_hh_groupk: {
    color: o([98, 213, 175]),
    value: "K - Significant Singles",
    categoricalLookup: ["K_p", "k_p"],
    visible: !0
  },
  cape_hh_groupl: {
    color: o([60, 100, 51]),
    value: "L - Blue Sky Boomers",
    categoricalLookup: ["L_p", "l_p"],
    visible: !0
  },
  cape_hh_groupm: {
    color: o([113, 205, 72]),
    value: "M - Families in Motion",
    categoricalLookup: ["M_p", "m_p"],
    visible: !0
  },
  cape_hh_groupn: {
    color: o([87, 146, 192]),
    value: "N - Pastoral Pride",
    categoricalLookup: ["N_p", "n_p"],
    visible: !0
  },
  cape_hh_groupo: {
    color: o([128, 128, 128]),
    value: "O - Single and Starters",
    categoricalLookup: ["O_p", "o_p"],
    visible: !0
  },
  cape_hh_groupp: {
    color: o([252, 249, 121]),
    value: "P - Cultural Connections",
    categoricalLookup: ["P_p", "p_p"],
    visible: !0
  },
  cape_hh_groupq: {
    color: o([101, 35, 32]),
    value: "Q - Golden Year Guardians",
    categoricalLookup: ["Q_p", "q_p"],
    visible: !0
  },
  cape_hh_groupr: {
    color: o([213, 201, 76]),
    value: "R - Aspirational Fusion",
    categoricalLookup: ["R_p", "r_p"],
    visible: !0
  },
  cape_hh_groups: {
    color: o([136, 124, 45]),
    value: "S - Thrifty Habits",
    categoricalLookup: ["S_p", "s_p"],
    visible: !0
  }
}, l = Object.values(e);
export {
  l as MOSAIC_BINS,
  e as MOSAIC_BIN_MAP
};
//# sourceMappingURL=index.es91.js.map
